import { translate } from '../../../common/utility/DisplayPrep';
const { READ_ONLY_FEATURES } = process.env;

const actions = READ_ONLY_FEATURES === 'true' ? ['edit'] : ['edit', 'delete'];

const defaultUiConfig = {
    name: 'Resources',
    withActions: [...actions],
    primaryKey: 'resourceId',
    pageSize: 10,
    properties: {
        resourceId: {
            name: 'ID',
            sortable: true,
            input: (v) => {
                return typeof v.resourceId !== 'undefined' ? 'valueDisplay' : null;
            }
        },
        name: {
            name: 'Name',
            sortable: true,
            rowDisplay: true,
            max: 512,
            min: 0,
            input: 'text'
        },
        description: {
            name: 'Description',
            defaultContent: '',
            min: 0,
            max: 2048,
            rowDisplay: false,
            sortable: true,
            input: 'multiline'
        },
        resourceType: {
            name: 'Resource Type',
            sortable: true,
            rowDisplay: true,
            nullable: false,
            input: 'select'
        },
        uuid: {
            rowDisplay: false,
            sortable: true,
            name: 'Uuid'
        },
        lastModId: {
            rowDisplay: false,
            sortable: true,
            name: 'Last Modified ID'
        },
        lastModDatetime: {
            rowDisplay: false,
            displayPrep: 'FullDate',
            name: 'Last Modified Datetime',
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        createId: {
            rowDisplay: false,
            name: 'Create ID'
        },
        createDatetime: {
            rowDisplay: false,
            name: 'Create Datetime'
        },
        auditId: {
            defaultContent: '',
            sortable: true,
            rowDisplay: false,
            name: 'Audit ID'
        }
    },
    newDoc: {
        createDatetime: null,
        createId: null,
        criteriaResourceParams: [],
        dtoState: 'NEW',
        lastModDatetime: null,
        lastModId: null,
        name: null,
        resourceId: null,
        resourceType: null,
        auditId: null,
        description: null
    },
    sortBy: {
        columnId: 'name',
        desc: false
    }
};

export default defaultUiConfig;
